import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-66d2045f"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "clone-el"
  }, null, -1);
});
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    src: "https://img.pipacoding.com/assets/ug-fe-contest/20250408/guide-1.png",
    alt: ""
  }, null, -1);
});
var _hoisted_3 = [_hoisted_2];
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "clone-el"
  }, null, -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    src: "https://img.pipacoding.com/assets/ug-fe-contest/20250408/guide-2.png",
    alt: ""
  }, null, -1);
});
var _hoisted_6 = [_hoisted_5];
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "clone-el"
  }, null, -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    src: "https://img.pipacoding.com/assets/ug-fe-contest/20250408/guide-3.png",
    alt: ""
  }, null, -1);
});
var _hoisted_9 = [_hoisted_8];
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { ScreenMediaService } from '@/services/recordVideo/media.service';
import { useService } from '@kaokei/use-vue-service';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var recordVideoService = useService(RecordVideoService);
    var screenMediaService = useService(ScreenMediaService);
    var curStep = ref(0);
    var guideMaskRef = ref(null);
    var StepList = [{
      target: '.guide-target[data-target="video"]',
      stepEl: '.step-1'
    }, {
      target: '.guide-target[data-target="time"]',
      stepEl: '.step-2'
    }, {
      target: '.guide-target[data-target="record-action"]',
      stepEl: '.step-3'
    }];
    var showNextStep = function () {
      if (curStep.value >= StepList.length - 1) {
        onCloseGuideMask();
        return;
        // curStep.value = 0;
      } else {
        curStep.value++;
      }
      showStep(curStep.value);
    };
    var showStep = function (step) {
      var _a, _b;
      var parent = guideMaskRef.value;
      StepList.forEach(function (item) {
        var el = parent === null || parent === void 0 ? void 0 : parent.querySelector(item.stepEl);
        if (el) {
          el.style.display = 'none';
        }
      });
      var stepEl = parent === null || parent === void 0 ? void 0 : parent.querySelector(StepList[step].stepEl);
      var targetEl = document.querySelector(StepList[step].target);
      if (!stepEl || !targetEl) return;
      var _c = targetEl.getBoundingClientRect(),
        left = _c.left,
        top = _c.top;
      stepEl.style.display = 'block';
      stepEl.style.position = 'fixed';
      stepEl.style.left = "".concat(left, "px");
      stepEl.style.top = "".concat(top, "px");
      stepEl.style.zIndex = '9999999';
      if (!((_a = stepEl.querySelector('.clone-el')) === null || _a === void 0 ? void 0 : _a.childNodes.length)) {
        var clonedNode = targetEl.cloneNode(true);
        // 如果是视频元素，手动复制 srcObject
        if (targetEl.getAttribute('data-target') === 'video') {
          var clonedVideo = clonedNode.querySelector('video');
          clonedVideo.srcObject = screenMediaService.stream; // 手动复制 srcObject
          clonedVideo.muted = true; // 设置静音
        }
        (_b = stepEl.querySelector('.clone-el')) === null || _b === void 0 ? void 0 : _b.appendChild(clonedNode);
      }
    };
    var onCloseGuideMask = function () {
      recordVideoService.toggleGuideMask(false);
      curStep.value = 0;
    };
    var resetDomPosition = function () {
      var step = curStep.value;
      var parent = guideMaskRef.value;
      var stepEl = parent === null || parent === void 0 ? void 0 : parent.querySelector(StepList[step].stepEl);
      var targetEl = document.querySelector(StepList[step].target);
      if (!stepEl || !targetEl) return;
      var _a = targetEl.getBoundingClientRect(),
        left = _a.left,
        top = _a.top;
      stepEl.style.display = 'block';
      stepEl.style.position = 'fixed';
      stepEl.style.left = "".concat(left, "px");
      stepEl.style.top = "".concat(top, "px");
    };
    onMounted(function () {
      nextTick(function () {
        showStep(curStep.value);
      });
      window.addEventListener('resize', resetDomPosition, false);
    });
    onUnmounted(function () {
      window.removeEventListener('resize', resetDomPosition, false);
    });
    return function (_ctx, _cache) {
      return _unref(recordVideoService).guideMaskVisible ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "guide-mask",
        ref: function (_value, _refs) {
          _refs['guideMaskRef'] = _value;
          guideMaskRef.value = _value;
        }
      }, [_createElementVNode("span", {
        class: "skip-tip",
        onClick: onCloseGuideMask
      }), _createElementVNode("div", {
        class: "guide-step step-1"
      }, [_hoisted_1, _createElementVNode("div", {
        class: "tips-el",
        onClick: showNextStep
      }, _hoisted_3)]), _createElementVNode("div", {
        class: "guide-step step-2"
      }, [_hoisted_4, _createElementVNode("div", {
        class: "tips-el",
        onClick: showNextStep
      }, _hoisted_6)]), _createElementVNode("div", {
        class: "guide-step step-3"
      }, [_hoisted_7, _createElementVNode("div", {
        class: "tips-el",
        onClick: showNextStep
      }, _hoisted_9)])], 512)) : _createCommentVNode("", true);
    };
  }
});